import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import {ViewordinericercaPage} from "../../pages/viewordinericerca/viewordinericerca";

/**
 * Generated class for the RicercaordinazionePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ricercaordinazione',
  templateUrl: 'ricercaordinazione.html',
})
export class RicercaordinazionePage {
  dataInvio;
  periodo;
  ordini;
  errorMessage;
  constructor(public navCtrl: NavController, public navParams: NavParams, public rest: RestApiProvider, ) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RicercaordinazionePage');
  }
  cerca() {
    console.log("cerca inizio:" + this.dataInvio);
    console.log("cerca periodo:" + this.periodo);

    if (this.dataInvio != null) {
      if (this.periodo == "d") {
        this.rest.getOrdineDayList(this.dataInvio).subscribe(
          ordini => this.ordini = ordini,
          error => this.errorMessage = <any>error);
      }
      if (this.periodo == "w") {
        this.rest.getOrdineWeekList(this.dataInvio).subscribe(
          ordini => this.ordini = ordini,
          error => this.errorMessage = <any>error);
      }
      if (this.periodo == "m") {
        this.rest.getOrdineMonthList(this.dataInvio).subscribe(
          ordini => this.ordini = ordini,
          error => this.errorMessage = <any>error);
      }
     

    }

  }
  openOrdinePage(ordine) {

    this.navCtrl.push(ViewordinericercaPage, { ordine: ordine });


  }

}



// WEBPACK FOOTER //
// ./src/pages/ricercaordinazione/ricercaordinazione.ts